<template>
  <div class="contacts__wrap">
    <div class="contacts">
      <h3>Haben Sie Fragen zu Ihrer Bestellung?</h3>
      <p>Wir sind bei Fragen gerne für Sie da.</p>
      <a class="contacts__phone" href="tel:00492119462550">+49 211 - 94 62 55 - 0</a>
      <div class="contacts__working-days">
        <p class="contacts__item"><b>Mo - Do</b> 08:30 - 17:00 Uhr</p>
        <p class="contacts__item"><b>Fr</b> 08:30 - 14:00 Uhr</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.contacts {
  position: relative;
  padding: 0.8125rem 0.625rem;
  background-color: #e5eded;
  &:after {
    content: '';
    position: absolute;
    right: 3%;
    bottom: 0;
    width: 30%;
    height: 68%;
    background: url("../assets/images/operator.png") no-repeat;
    background-size: contain;
  }
  h3 {
    margin-bottom: 0.1875rem;
    font-size: 0.875rem;
    font-weight: 700;
  }
  > p {
    font-size: 0.75rem;
  }
  &__wrap {
    padding: 0 0.625rem 1.25rem;
  }
  &__phone {
    display: inline-block;
    margin: 0.625rem 0;
    padding: 0.125rem 1.875rem 0.125rem;
    border: 0.0625rem solid $red;
    border-radius: 1.5625rem;
    background-color: #ffffff;
    font-size: 0.75rem;
    line-height: 1.875rem;
    font-weight: 700;
    line-height: 1.875rem;
    color: $red;
  }
  &__working-days {
    font-size: 0.75rem;
    p {
      margin-bottom: 0.625rem;
    }
    b {
      display: inline-block;
      width: 5rem;
    }
  }
  @include breakpoint(tablet) {
    margin-top: 1.25rem;
    padding: 2.5625rem 33% 1.9375rem 2.5625rem;
    &__wrap {
      padding: 0;
    }
    h3 {
      font-size: 1.25rem;
    }
    > p {
      font-size: 1rem;
    }
    &__phone {
      max-width: 18.3125rem;
      margin-bottom: 1.25rem;
      font-size: 0.875rem;
    }
    &__working-days {
      font-size: 1rem;
    }
  }
  @include breakpoint(desktop) {
    &:after {
      width: 33%;
      height: 90%;
    }
    &__phone {
      font-size: 16px;
    }
  }
}
</style>
